import React from 'react';

import classes from './Block.css';

import Section from '../../../hoc/Section/Section';

const blockContent = (props) => {

    const getIdFromLink = () => {
        if (props.link) {
            const link = props.link.split("#");
            if (link.length > 0) return link[1];
        }

        return "" ; 
    }

    return (
        
        <div className={classes.Main}>
            <div className={classes.Image} data-clippath={classes.SwitchColor}>
                <img src={props.image} alt='' />
            </div>

        {props.link && props.mainSection ? <Section link={props.link} mainSection={props.mainSection}/> : null}

        <div className={classes.Content}>

            <div className={classes.Title} id={getIdFromLink()}>
                {props.title}
            </div>
            <div className={classes.Text}>
                {props.children}
            </div>
            <div className={classes.Skills}>
                {props.skills ? props.skills.map(skill => {
                    return <div key={skill} className={classes.Flex50}>{skill}</div>
                }) : null}
            </div>
        </div>

        </div>
        
    );
} 

export default blockContent;


// WEBPACK FOOTER //
// ./client/src/components/BlockContent/Services/Block.js